/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger-menu': {
    width: 18,
    height: 15,
    viewBox: '0 0 18 15',
    data:
      '<g _stroke="#A363FF" stroke-width="3" stroke-linecap="round"><path pid="0" d="M2 1.5h14M2 7.5h14M2 13.5h14"/></g>'
  }
})
